// extracted by mini-css-extract-plugin
module.exports = {"phone":"_101If","free":"G05PH"};